/**
 * A frase de erro que pode IR PARA A TELA — e a que não pode.
 *
 * ★ **Nasceu no Advisory Hub (G-11 do QA it.2) e subiu para cá na 3ª rodada de
 * review do PR #2342**, quando o segundo consumidor apareceu: a conversa que
 * não abriu (`view-chat.vue::descartarConversaQueNaoAbriu`) mandava `r.message`
 * direto ao snack, e numa queda de rede o consultor lia `Network Error(500)`
 * no meio do chat.
 *
 * `services/connection.js` (`request.catch`) grava em `r.message` a string
 * TÉCNICA crua — `(error.message || 'Erro inesperado...') + '(' + status + ')'`
 * —, nunca uma frase escrita para quem lê: `Network Error(500)`, `timeout of
 * 30000ms exceeded(500)`.
 *
 * ⚠️ **O discriminante é o SUFIXO `(NNN)`, e ele é deliberadamente estreito.**
 * Nenhuma `message` de negócio do backend (400/403/409, sempre PT-BR de
 * propósito) termina em número entre parênteses. Alargar a régua — por
 * exemplo, recusar toda frase sem acento — trocaria um defeito visível por
 * outro pior: a copy genérica da casa por cima do motivo REAL que o servidor
 * mandou, que é justamente o que o consultor precisa ler.
 *
 * ★ **Não é para consertar no `connection.js`**: ele é compartilhado pelo app
 * inteiro e a string técnica ainda é o que o log precisa. Quem decide o que a
 * TELA lê é o consumidor.
 *
 * Sem `?.`/`??` (o Babel deste projeto não transpila). Acentos UTF-8 reais.
 */

/** O rastro de `connection.js`: a frase termina em `(NNN)`. */
export const SUFIXO_MENSAGEM_TECNICA = /\(\d+\)\s*$/

/**
 * Escolhe entre a mensagem do BACKEND e uma copy local.
 *
 * @param {Object} r Envelope da API (`{status, message, value}`).
 * @param {String} fallback A copy da casa, para quando não há frase utilizável.
 * @returns {String}
 * @example mensagemAmigavelDoErro({message: 'Network Error(500)'}, 'Não abriu.')
 */
export function mensagemAmigavelDoErro(r, fallback) {
  const mensagem = r && r.message
  if (!mensagem || SUFIXO_MENSAGEM_TECNICA.test(mensagem)) return fallback
  return mensagem
}
